module.exports = __webpack_public_path__ + "static/media/depositSlide4.56d437e5.svg";